import { isValidEmail } from '@/utils/email';

/** localStorage draft for /smokerprofile — merged with other survey data on final submit. */
export const SMOKER_PROFILE_STORAGE_KEY = 'npdsurvey:smokerProfile';

export type SmokerProfileAnswers = {
  name: string;
  email: string;
  race: string;
  state: string;
  /** Kept for API shape; Dice flow no longer collects brand/variant. */
  brand: string;
  variant: string;
};

export function readSmokerProfileAnswers(): Partial<SmokerProfileAnswers> | null {
  try {
    const raw = localStorage.getItem(SMOKER_PROFILE_STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as unknown;
    if (typeof o !== 'object' || o === null) return null;
    const p = o as Record<string, unknown>;
    return {
      name: typeof p.name === 'string' ? p.name : '',
      email: typeof p.email === 'string' ? p.email : '',
      race: typeof p.race === 'string' ? p.race : '',
      state: typeof p.state === 'string' ? p.state : '',
      brand: typeof p.brand === 'string' ? p.brand : '',
      variant: typeof p.variant === 'string' ? p.variant : '',
    };
  } catch {
    return null;
  }
}

export function writeSmokerProfileAnswers(data: SmokerProfileAnswers): void {
  try {
    localStorage.setItem(SMOKER_PROFILE_STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* quota / private mode */
  }
}

export function clearSmokerProfileAnswers(): void {
  try {
    localStorage.removeItem(SMOKER_PROFILE_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isSmokerProfileComplete(): boolean {
  const s = readSmokerProfileAnswers();
  if (!s) return false;
  const { name, email, race, state } = s;
  return (
    typeof name === 'string' &&
    name.trim().length > 0 &&
    isValidEmail(email) &&
    typeof race === 'string' &&
    race.trim().length > 0 &&
    typeof state === 'string' &&
    state.trim().length > 0
  );
}
